import { render, staticRenderFns } from "./credit-year-selector.vue?vue&type=template&id=6262edec&scoped=true"
import script from "./credit-year-selector.vue?vue&type=script&lang=ts"
export * from "./credit-year-selector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6262edec",
  null
  
)

export default component.exports